import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  accessToken: null,
  refreshToken: null,
  error: null,
  memoryUser: {
    email: "admin@ryse.ai",
    password: "rY*sE+a1",
    profile: { id: "1", name: "Ryse Admin", email: "admin@ryse.ai" },
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    signInWithMemory: (state, { payload }) => {
      const { email, password } = payload || {};
      const { memoryUser } = state;

      if (email === memoryUser.email && password === memoryUser.password) {
        state.user = memoryUser.profile;
        state.accessToken = "ACCESS_TOKEN_DEV";
        state.refreshToken = "REFRESH_TOKEN_DEV";
        state.error = null;
      } else {
        state.user = null;
        state.accessToken = null;
        state.refreshToken = null;
        state.error = "Credenciales inválidas";
      }
    },
    signedOut: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.error = null;
    },
    clearAuthError: (state) => {
      state.error = null;
    },
    signIn: (state, { payload }) => {
      const { user, accessToken, refreshToken } = payload || {};
      state.user = user || { email: payload?.email || payload?.username };
      state.accessToken = accessToken || "ACCESS_TOKEN";
      state.refreshToken = refreshToken || "REFRESH_TOKEN";
      state.error = null;
    },
  },
});

export const { signInWithMemory, signedOut, clearAuthError, signIn } = authSlice.actions;
export default authSlice.reducer;